export default __webpack_public_path__ + "static/media/coach.62f4218a.png";